import axios from 'axios';
import { API_BASE_URL, STORAGE_KEYS } from '../constants';

export const refreshAccessToken = async (): Promise<string | null> => {
  try {
    const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
    
    if (!refreshToken || refreshToken === 'undefined' || refreshToken === 'null') {
      clearAuthData();
      return null;
    }

    const response = await axios.post(`${API_BASE_URL}/auth/token/refresh/`, { 
      refresh: refreshToken 
    });
    
    const { access } = response.data;
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, access);
    return access;
  } catch {
    clearAuthData();
    return null;
  }
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp < currentTime;
  } catch {
    return true; // Assume expired if we can't parse
  }
};

export const getTokenExpirationTime = (token: string): number | null => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000; // Convert to milliseconds
  } catch {
    return null;
  }
};

export const clearAuthData = (): void => {
  localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.USER_DATA);
};

export const debugTokens = (): void => {
  // Never leak token material to the console in production builds.
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  const accessToken = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
  
  console.log('=== Token Debug Info ===');
  console.log('Access Token:', accessToken ? `${accessToken.substring(0, 20)}...` : 'null/undefined');
  console.log('Refresh Token:', refreshToken ? `${refreshToken.substring(0, 20)}...` : 'null/undefined');
  console.log('Access Token Type:', typeof accessToken);
  console.log('Refresh Token Type:', typeof refreshToken);
  console.log('=======================');
};

export const checkAndRefreshToken = async (): Promise<boolean> => {
  const accessToken = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
  
  if (!accessToken || !refreshToken || refreshToken === 'undefined' || refreshToken === 'null') {
    clearAuthData();
    return false;
  }
  
  if (isTokenExpired(accessToken)) {
    const newToken = await refreshAccessToken();
    return newToken !== null;
  }
  
  return true;
}; 